// extracted by mini-css-extract-plugin
module.exports = {"error-message":"two-pane-modal-form__error-message___2Vr6m"};